import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PublicLayout } from "@/components/PublicLayout";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, refreshUser } = useAuth();
  const [state, setState] = useState(token ? "ready" : "error");
  const [msg, setMsg] = useState("This link is invalid or has expired.");
  const [email, setEmail] = useState("");

  const confirm = async () => {
    setState("busy");
    try {
      const { data } = await api.post("/auth/email-change/confirm", { token });
      setEmail(data.email);
      setState("done");
      if (user) refreshUser();
    } catch (e) {
      setMsg(errMsg(e, "This link is invalid or has expired."));
      setState("error");
    }
  };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-5 pt-14">
        <div className="mm-card p-8 text-center" data-testid="confirm-email-card">
          {(state === "ready" || state === "busy") && (
            <>
              <h1 className="text-3xl font-bold">Confirm your new email</h1>
              <p className="text-mm-muted mt-2">Tap below to make this your sign-in email.</p>
              <button className="mm-btn mt-6" onClick={confirm} disabled={state === "busy"} data-testid="confirm-email-button">
                {state === "busy" ? <Loader2 size={16} className="animate-spin" /> : "Confirm email"}
              </button>
            </>
          )}
          {state === "done" && (
            <>
              <CheckCircle2 className="mx-auto text-mm-success" size={52} />
              <h1 className="text-3xl font-bold mt-3" data-testid="confirm-email-done">Email updated</h1>
              <p className="text-mm-muted mt-2">From now on, sign in with <b>{email}</b>.</p>
              <Link to={user ? "/settings" : "/login"} className="mm-btn mt-6" data-testid="confirm-email-continue">{user ? "Back to Settings" : "Log in"}</Link>
            </>
          )}
          {state === "error" && (
            <div data-testid="confirm-email-error">
              <h1 className="text-2xl font-bold">Link not valid</h1>
              <p className="text-mm-muted mt-2">{msg}</p>
              <Link to={user ? "/settings" : "/login"} className="mm-btn mt-6">{user ? "Go to Settings" : "Log in"}</Link>
            </div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
